import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { withStyles } from 'material-ui/styles';

import Grid from 'material-ui/Grid';
import Input, { InputLabel } from 'material-ui/Input';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';

import { getAvailableFilters } from '../../../inspection/inspection.selectors';
import { getFilters } from '../../../reports/reports.selectors';
// import { getAvailableFilters } from '../../../inspection/inspection.actions';

import styles from './styles';

const propTypes = {
    columns: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
};

const defaultProps = {
    availableFilters: [],
};

class Filters extends React.Component {
    componentDidMount() {
        // const { getAvailableFilters } = this.props;
        // getAvailableFilters();
    }

    render() {
        const {
            filters,
            columns,
            availableFilters,
            classes,
            handleFiltersChanged
        } = this.props;
        return (
            <Grid container className={classes.filters}>
                {columns.map((field, id) => {
                    if (field.disableFiltering || field.id in availableFilters === false) return null;
                    const sortFunction = (a, b) => {
                        if (typeof a === 'string') {
                            a = a.toLowerCase().replace(/\s/g, '');
                            b = b.toLowerCase().replace(/\s/g, '');
                            return a > b ? 1 : -1;
                        }
                        if (a.name) {
                            return a.name > b.name ? 1 : -1;
                        }
                        if (a.label) {
                            return a.label > b.label ? 1 : -1;
                        }
                        if (a.value) {
                            return a.value > b.value ? 1 : -1;
                        }
                        return a > b ? 1 : -1;

                    }
                    const options = ['all', ...availableFilters[field.id].sort(sortFunction)];
                    const selectedFilter = filters.find(filter => filter.field === field.id);
                    return (
                        <Grid item key={id}>
                            <FormControl>
                                <InputLabel htmlFor={field.id}>{field.label}</InputLabel>
                                <Select
                                    value={selectedFilter ? selectedFilter.value.value : 'all'}
                                    onChange={(event, i) => {
                                        handleFiltersChanged(event, i, field.id);
                                    }}
                                    input={<Input disableUnderline id={field.id} className={classes.input} />}
                                >
                                    {options.map((option, index) => {
                                        let item = option;
                                        let name = option;
                                        if (typeof option === 'object') {
                                            if ('label' in option) {
                                                if ('value' in option) item = option.value;
                                                else item = option.label;
                                                name = option.label;
                                            } else {
                                                item = option.name;
                                                name = option.name;
                                            }
                                        }
                                        if (name === 'all') {
                                            name = 'Kaikki';
                                        }
                                        return (
                                            <MenuItem key={index} value={item}>
                                                {name}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                    );
                })}
            </Grid>
        );
    }
}

Filters.propTypes = propTypes;
Filters.defaultProps = defaultProps;

const mapStateToProps = state => {
    // const availableFilters = getAvailableFilters(state);
    const filters = getFilters(state);

    return {
        // availableFilters,
        filters,
    };
};

export default connect(mapStateToProps, { getAvailableFilters })(withStyles(styles)(Filters));



// WEBPACK FOOTER //
// ./src/modules/common/components/table/Filters.js